import React, { useState, useRef, useEffect } from "react";
import "./dropdown.css";
import DropDownIcon from "../../../Assets/Images/EployeeRegistration/icon-dropdown-menu.png";

function normalizeSelectedForCompare(val) {
  if (val === null || val === undefined || val === "") return null;
  if (typeof val === "boolean") return String(val).toLowerCase(); // "true"/"false"
  if (typeof val === "number") return String(val); // "1"/"0"
  return String(val).trim().toLowerCase(); // "true"/"false"/"1"/"0"/etc
}

export default function DropDown({
  width,
  label,
  selected,
  setSelected,
  options = [],
  customWidth,
  customTop,
  isRequired,
  Height,
  OverFlow,
  minheight,
  placeholder = "",
  marginLeft,
  marginTop,
  position,
  disabled = false,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Sync selected -> label in a robust tolerant way
  useEffect(() => {
    const norm = normalizeSelectedForCompare(selected);
    if (norm === null) {
      setSelectedLabel("");
      return;
    }

    // 1) exact id match (stringified)
    let found = options.find((opt) => String(opt.id) === String(selected));
    if (found) {
      setSelectedLabel(found.label);
      return;
    }

    // 2) try matching by normalized option id or label
    found = options.find((opt) => {
      const optNorm = normalizeSelectedForCompare(opt.id ?? opt.label);
      const labelNorm = normalizeSelectedForCompare(opt.label);
      return optNorm === norm || labelNorm === norm;
    });
    if (found) {
      setSelectedLabel(found.label);
      return;
    }

    // 3) fallback: show raw value if it's readable
    setSelectedLabel(typeof selected === "string" || typeof selected === "number" ? String(selected) : "");
  }, [selected, options]);

  const handleClick = (option) => {
    if (disabled) return;
    // Keep parent behavior: send option.id
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  return (
    <div
      className="dropdown"
      style={{
        width,
        marginLeft,
        marginTop,
        opacity: disabled ? 0.6 : 1,
        pointerEvents: disabled ? "none" : "auto",
      }}
      ref={dropdownRef}
    >
      <label>
        {label}
        {isRequired && <span>*</span>}
      </label>

      <div
        className="dropdown-btn"
        onClick={() => !disabled && setIsActive(!isActive)}
        style={{
          backgroundColor: disabled ? "#f5f5f5" : "white",
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingRight: "8px",
        }}
      >
        <span style={{ color: selectedLabel ? "#6A6A6A" : "#aaa" }}>
          {selectedLabel || placeholder}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          {/* CLEAR (×) removed as requested */}
          <img src={DropDownIcon} alt="dropdown-icon" />
        </div>
      </div>

      {isActive && !disabled && (
        <div
          className="dropdown-content"
          style={{
            width: customWidth,
            top: customTop,
            maxHeight: minheight,
            height: Height,
            overflow: OverFlow,
            position: position,
          }}
        >
          {options.map((option) => (
            <div
              key={option.id + String(option.label)}
              className="dropdown-item"
              onClick={() => handleClick(option)}
            >
              {option.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
